import classNames from 'classnames';
import type { AppPromoBlockProps } from './AppPromoBlock.types';
import { useState } from 'react';
import { useBreakpoint } from '@/hooks/useBreakpoint';

const AppPromoBlock: React.FC<AppPromoBlockProps> = ({
  imageFirst,
  image,
  youtubeUrl,
  title,
  hideImageOnMobile,
  content,
  imageSize,
  imageDisplay,
  appStoreLink,
  googleStoreLink,
}) => {
  const hasAppLinks = appStoreLink || googleStoreLink;
  const [playVideo, setPlayVideo] = useState(false);
  const { isMobile } = useBreakpoint();

  const showImage = image && ((isMobile && !hideImageOnMobile) || !isMobile);

  return (
    <div className="rewards-intro">
      <div
        className={classNames('rewards-intro__container', {
          'rewards-intro__container--image-left': imageFirst,
          'rewards-intro__container--image-right': !imageFirst,
          'rewards-intro__container--no-image': !image,
          'rewards-intro__container--video': youtubeUrl,
        })}
      >
        <div className="rewards-intro__section">
          {showImage && (
            <div
              className={`rewards-intro__image rewards-intro__image--${imageDisplay}`}
              style={{
                backgroundImage: `url(${image})`,
                backgroundSize: imageSize,
              }}
            >
              {youtubeUrl && (
                <div
                  className={`rewards-intro__video ${playVideo ? 'playing' : 'paused'}`}
                >
                  <button onClick={() => setPlayVideo(true)} title="Play video">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                      <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445" />
                    </svg>
                  </button>

                  {playVideo && (
                    <iframe
                      width="100%"
                      height="100%"
                      src={`${youtubeUrl}&autoplay=1`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        <div
          className={`rewards-intro__section  ${
            imageFirst
              ? 'rewards-intro__section--content-right'
              : 'rewards-intro__section--content-left'
          }`}
        >
          <h2 className="rewards-intro__heading">{title}</h2>
          {content && (
            <div
              className="rewards-intro__summary"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}

          {hasAppLinks && (
            <div className="rewards-intro__app-links">
              {appStoreLink && (
                <a
                  className="rewards-intro__app-link"
                  href={appStoreLink}
                  target="_blank"
                  data-app-link="iOS"
                  rel="noreferrer"
                >
                  <img
                    className="rewards-intro__app-image"
                    src="/_resources/app/client/img/app-store.svg"
                    alt="Download on the App Store"
                  />
                </a>
              )}
              {googleStoreLink && (
                <a
                  className="rewards-intro__app-link"
                  href={googleStoreLink}
                  target="_blank"
                  data-app-link="Android"
                  rel="noreferrer"
                >
                  <img
                    className="rewards-intro__app-image"
                    src="/_resources/app/client/img/google-play.svg"
                    alt="Get it on Google Play"
                  />
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AppPromoBlock;
